var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.canEditAudience
      ? _c(
          "div",
          { staticClass: "controls" },
          [
            _c(
              "Button",
              {
                staticClass: "control-button",
                nativeOn: {
                  click: function($event) {
                    return _vm.saveAudience($event)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "AudienceManager_Builder_Overview_SaveConceptButton"
                    )
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "Button",
              {
                staticClass: "control-button",
                attrs: { "component-style": "primary" },
                nativeOn: {
                  click: function($event) {
                    return _vm.publishAudience($event)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "AudienceManager_Builder_Overview_PublishButton"
                    )
                  )
                )
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("h3", { staticClass: "overview-title" }, [
      _vm._v(_vm._s(_vm.resource("AudienceManager_Builder_Overview_Title")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "current-selection-box" }, [
      _c("h4", { staticClass: "selection-title" }, [
        _vm._v(
          _vm._s(
            _vm.resource(
              "AudienceManager_Builder_Overview_CurrentSelectionTitle"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "current-selection" },
        [
          _c("answers", { staticClass: "item-answers" }),
          _vm._v(" "),
          false
            ? _c("circle-chart", {
                staticClass: "item-circle-chart",
                attrs: {
                  "audience-id": _vm.audienceId,
                  "background-color": "#FAFAFA"
                }
              })
            : _c("div", { staticClass: "item-circle-chart" }),
          _vm._v(" "),
          _c("estimate", { staticClass: "item-estimate" }),
          _vm._v(" "),
          _c("div", { staticClass: "item-pie-chart" }, [_vm._v(" ")])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }